var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2884 14.3747L7.22617 14.2988C5.91092 14.2723 4.5924 14.3251 3.30294 14.051C1.34138 13.6415 1.20241 11.6336 1.057 9.94939C0.856641 7.58155 0.934207 5.17074 1.31232 2.82266C1.52577 1.50514 2.3658 0.718973 3.66488 0.633423C8.05023 0.322948 12.4647 0.359743 16.8404 0.50459C17.3025 0.517869 17.7678 0.590445 18.2235 0.673056C20.4728 1.07597 20.5276 3.35137 20.6734 5.26683C20.8189 7.20205 20.7575 9.14721 20.4795 11.0693C20.2566 12.6607 19.8299 13.9952 18.0296 14.124C15.7738 14.2925 13.5698 14.4281 11.3077 14.3849C11.3078 14.3747 11.2948 14.3747 11.2884 14.3747ZM8.90019 10.3457C10.6001 9.34831 12.2676 8.36752 13.9577 7.3768C12.2547 6.37939 10.5904 5.3986 8.90019 4.40788V10.3457Z",
    fill: "#024E82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.43bbe8213707a406ba150a73dd89d114.svg";
export { ForwardRef as ReactComponent };